var React = require('react');

function DownloadArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.6189 28.2687L26.1899 23.3458C26.5695 23.0286 26.6045 22.4024 26.2733 22.0346C25.942 21.6668 25.3109 21.6296 24.9519 21.9709L20.9284 25.5283V13.423C20.9284 12.9135 20.5125 12.5 19.9999 12.5C19.4873 12.5 19.0714 12.9135 19.0714 13.423V25.5283L15.0479 21.9709C14.6888 21.6308 14.0589 21.6765 13.7277 22.0442C13.3964 22.412 13.429 23.0297 13.8099 23.3459L19.3809 28.2687C19.8318 28.5896 20.2356 28.5643 20.6189 28.2687L20.6189 28.2687Z","fill":"white","key":1})]);
}

DownloadArrow.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = DownloadArrow;

DownloadArrow.default = DownloadArrow;
